import AddVideoBatchItem from '../../../../../project-manager/files/i-services/models/request/AddVideoBatchItem';

/**
 * * Модель запроса на добавление видео
 */
export default class AddVideoBatchRequest  {
	/**
	 * * Список видео
	 */
	Videos!: Array<AddVideoBatchItem>;
	/**
	 * * Номер задачи
	 */
	TaskId?: number;
	/**
	 * * Номер очереди
	 */
	QueueTaskId?: string;
	/**
	 * * Номер чата
	 */
	ChatId?: string;
	/**
	 * * Номер папки
	 */
	FolderId!: string;
	constructor(obj?: Partial<AddVideoBatchRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
